import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import './GlobalDisclaimer.scss';

const GlobalDisclaimer = ({ ui }) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerText, setDisclaimerText] = useState(ui.globalDisclaimer);

  const updateDisclaimer = () => {
    const selectedAccordionId = window.selectedConfig?.selectedAccordion?.[0]?.replace('accordion_', '');
    const selectedSubmenuId = window.selectedConfig?.currentSelectedSubmenu;
    const selectedHotspotId = window.selectedConfig?.currentSelectedHotspot;
    // console.log(selectedAccordionId)
    let show = false;
    let text = ''; // clear previous text

    // 1️⃣ HOTSPOT HAS HIGHEST PRIORITY
    if (selectedHotspotId) {
      let hotspotFound = false;
      for (const sub of window.config.allSubmenu || []) {
        const hotspot = sub.hotspotDataInfo?.find(h => h.hsname === selectedHotspotId);
        if (hotspot && hotspot.showGlobalDisclaimer) {
          show = true;
          text = hotspot.disclaimerText ?? ui.globalDisclaimer;
          hotspotFound = true;
          break;
        }
      }
      if (!hotspotFound) {
        show = false;
        text = '';
      }
    }
    // 2️⃣ SUBMENU IF NO HOTSPOT
    else if (selectedSubmenuId && selectedSubmenuId !== selectedAccordionId) {
      const submenu = window.config.allSubmenu?.find(sub => sub.id === selectedSubmenuId);
      if (submenu?.showGlobalDisclaimer) {
        show = true;
        text = submenu.disclaimerText ?? ui.globalDisclaimer;
      }
    }
    // 3️⃣ ACCORDION IF NO SUBMENU OR HOTSPOT
    else if (selectedAccordionId) {
      // console.log("Accordion ID:", selectedAccordionId);
      const accordion = window.selectedConfig.menuList?.find(acc => acc.id === selectedAccordionId);
      // console.log("Accordion object:", accordion);
      if (accordion?.showGlobalDisclaimer) {
        show = true;
        text = accordion.disclaimerText ?? ui.globalDisclaimer;
      }
    }
    // 4️⃣ ONLOAD / FALLBACK
    else {
      show = false;
      text = ui.globalDisclaimer;
    }

    setShowDisclaimer(show);
    setDisclaimerText(text);
  };

  useEffect(() => {
    const interval = setInterval(updateDisclaimer, 200);
    return () => clearInterval(interval);
  }, []);

  if (!showDisclaimer) return null;

  return ReactDOM.createPortal(
    <div id="disclaimer">
      {disclaimerText}
    </div>,
    document.getElementById("globaDisclaimer")
  );
};

export default GlobalDisclaimer;
